import { toBoolPromise } from "@/utils/task";
import { ElForm } from "element-ui/types/form";

export const utilMixin = {
    methods: {
        $validateElForm(ref: ElForm) {
            return toBoolPromise(ref.validate())
        }
    }
}
declare module 'vue/types/vue' {
    interface Vue {
        $validateElForm(ref: ElForm): Promise<boolean>
    }
}
